import React, { useEffect, useState, useRef } from "react";
import API from "../Services/Report";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx";
import CenterModal from "../Components/CenterSelectorModal";
const VoidTransaction = () => {
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];

    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];

    const [currentPage, setCurrentPage] = useState(1);
    const [transaction, setTransaction] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalOrderAmount, setTotalOrderAmount] = useState(0);
    const perPage = 10;
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [search, setSearch] = useState({
        searchText: "",
        from_date: formattedToday,
        to_date: formattedToday,

    });
    // useEffect(() => {
    //     if (selectedCenter.length > 0) {
    //         bindTransactionData(currentPage);
    //     }
    // }, [selectedCenter, currentPage]);
    useEffect(() => {
        bindTransactionData(1);
    }, []);
    useEffect(() => {
        if (currentPage !== 1) {
            bindTransactionData(currentPage);
        }
    }, [currentPage]);
    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        setSearch((prev) => ({
            ...prev,
            [fieldName]: value
        }));
    };

    useEffect(() => {
        if (search.from_date) {
            const newToDate = moment(search.from_date).add(90, "days");

            const finalToDate = newToDate.isAfter(moment())
                ? moment().format("YYYY-MM-DD")
                : newToDate.format("YYYY-MM-DD");

            setSearch((prev) => ({
                ...prev,
                to_date: finalToDate
            }));
        }
    }, [search.from_date]);

    const handleSearch = () => {
        setCurrentPage(1);
        bindTransactionData(1);
    };

    const bindTransactionData = async (currentPage) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payload = {
                start_date: search.from_date || formattedPastDate,
                end_date: search.to_date || formattedToday,
                location_id: centerlist || null
            };

            const response = await API.getVoidTransactionReport(payload);

            const result = response?.data?.result || [];

            if (
                result.length === 1 &&
                result[0]?.total_order_amount === null &&
                Object.keys(result[0]).length === 1
            ) {
                setTransaction([]);
                setTotalOrderAmount(0);
                setTotalCount(0);
                setTotalPages(0);
                return;
            }

            let transactionData = result;
            let totalAmount = 0;

            if (
                result.length > 0 &&
                result[result.length - 1].hasOwnProperty("total_order_amount")
            ) {
                totalAmount = result[result.length - 1].total_order_amount || 0;
                transactionData = result.slice(0, -1);
            }

            setTransaction(transactionData);
            setTotalOrderAmount(totalAmount);

            setTotalCount(transactionData.length);
            setTotalPages(Math.ceil(transactionData.length / perPage));

        } catch (error) {
            handleError(error);

            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };
    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;
    const paginatedData = transaction.slice(startIndex, endIndex);

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, "...");
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push("...", totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };
    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
        // console.log('dddd',selectedData);
    };
      const downloadCSV = async () => {
            try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payload = {
                start_date: search.from_date || formattedPastDate,
                end_date: search.to_date || formattedToday,
                location_id: centerlist || null
            };
            const response = await API.getVoidTransactionReport(payload);
            const result = response?.data?.result || [];
            if (!result.length) {
            toast.error("No data found!");
            return;
                }
                const worksheet = XLSX.utils.json_to_sheet(result);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "VoidTransactionReport");
                XLSX.writeFile(workbook, "VoidTransactionReport.xlsx");
            } catch (error) {
                console.error("Error downloading Excel:", error);
            }
        };
    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Total Void Transaction Report ({transaction?.length})</h4>
                            {totalCount > 0 && (
                                <div className="col-md-1">
                                    <button
                                        className="btn btn-primary"
                                        onClick={downloadCSV}
                                    >
                                        <i className="fa fa-download"></i>
                                    </button>
                                </div>
                            )}

                    </div>

                    <div className="card-body">
                        <div className="row mb-2">
                            <div className="col-md-3">
                                <CenterModal onSelectCenter={handleSelectedCenter} />
                            </div>

                            <div className="col-md-3">
                                <label>From Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={search.from_date || ""}
                                    // min={formattedPastDate}
                                    max={formattedToday}
                                    onChange={(e) => handleFieldChange(e, "from_date")}
                                />
                            </div>

                            <div className="col-md-3">
                                <label>To Date</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    value={search.to_date || ""}
                                    min={search.from_date}
                                    max={
                                        search.from_date
                                            ? moment(search.from_date).add(90, "days").isAfter(moment())
                                                ? moment().format("YYYY-MM-DD")
                                                : moment(search.from_date).add(90, "days").format("YYYY-MM-DD")
                                            : formattedToday
                                    }
                                    onChange={(e) => handleFieldChange(e, "to_date")}
                                />
                            </div>

                            <div className="col-md-3 d-flex align-items-end">
                                <button
                                    onClick={handleSearch}
                                    className="btn btn-success w-100"
                                    type="button"
                                >
                                    Search
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>Sr No</th>
                                        <th>Void By</th>
                                        <th>Order Id</th>
                                        <th>Order Type</th>
                                        <th>Center Name</th>
                                        <th>Order Amount</th>
                                        <th>Order Place Date</th>
                                        <th>Void Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {paginatedData.length > 0 ? (
                                        <>
                                            {paginatedData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{startIndex + index + 1}</td>
                                                    <td>{item.void_byA}</td>
                                                    <td>{item.order_id}</td>
                                                    <td>{item.order_type}</td>
                                                    <td>{item.center_name}</td>
                                                    <td>₹{item.order_amount}</td>
                                                    <td>
                                                        {moment.utc(item.order_place_on).format("DD-MM-YYYY HH:mm:ss")}
                                                    </td>
                                                    <td>
                                                        {moment.utc(item.void_date).format("DD-MM-YYYY HH:mm:ss")}
                                                    </td>
                                                </tr>
                                            ))}

                                            {/* Total Row */}
                                            <tr className="fw-bold">
                                                <td colSpan="5" className="text-end">
                                                    Total Order Amount
                                                </td>
                                                <td>₹{totalOrderAmount}</td>
                                                <td colSpan="2"></td>
                                            </tr>
                                        </>
                                    ) : (
                                        <tr>
                                            <td colSpan="8">No data found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""
                                                } ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(page)}
                                                >
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default VoidTransaction;
